import { Container, Tabs, Alert } from "@mantine/core";
import { IconCalendarCog, IconPrompt } from "@tabler/icons-react";
import { useSearch, useLocation } from "wouter";
import { useBrandContext } from "../Brands/brandContext";
import { useBrand } from "../Brands/useBrand";
import BrandMonitors from "../Brands/BrandMonitors";
import PromptsList from "../Prompts/PromptsList";

export default function LlmConfigPage() {
  const { selectedBrand } = useBrandContext();
  const brand = useBrand(selectedBrand?.id);
  const [, setLocation] = useLocation();

  const searchString = useSearch();
  const tabFromUrl = new URLSearchParams(searchString).get("tab");

  // Unknown tabs fall back instead of setting a Tabs value with no matching panel, which renders
  // the tab strip above nothing at all. Same guard as SettingsPage, for the same reason: prompts
  // moved here from /settings, so links between the two pages will go stale again.
  const activeTab = ["monitors", "prompts"].includes(tabFromUrl)
    ? tabFromUrl
    : "monitors";

  if (!selectedBrand) {
    return (
      <Container>
        <Alert color="blue" mt="md">
          Please select a brand from the switcher above to view LLM configuration.
        </Alert>
      </Container>
    );
  }

  if (!brand) {
    return null;
  }

  return (
    // xl rather than the theme's 800px default. Both tabs are wide tables — eight columns of prompt
    // counts, and a prompt list whose type badges were being ellipsised into "AWARENESS…" purely
    // because the page they sit on was half the width of the window.
    <Container size="xl">
      <Tabs
        keepMounted={false}
        value={activeTab}
        onChange={(tab) => setLocation(`/llm-config?tab=${tab}`)}
      >
        <Tabs.List>
          <Tabs.Tab
            value="monitors"
            leftSection={<IconCalendarCog size={16} stroke={1.5} />}
          >
            Monitors
          </Tabs.Tab>
          <Tabs.Tab
            value="prompts"
            leftSection={<IconPrompt size={16} stroke={1.5} />}
          >
            Prompts
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="monitors">
          <BrandMonitors params={{ brandId: brand.id }} />
        </Tabs.Panel>
        <Tabs.Panel value="prompts">
          <PromptsList params={{ brandId: brand.id }} />
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
}
